// @flow

import React from 'react';
import { SelectProps } from 'antd/lib/select';
import { attachedEquipmentTypes } from '../../../lib/enum';
import { Select, Option } from '../../ant/Select';

// Список типов навесного оборудования
export default (props: SelectProps) => (
  <Select {...props}>
    {Object.keys(attachedEquipmentTypes).map(key => (
      <Option value={key} key={key}>
        {attachedEquipmentTypes[key]}
      </Option>
    ))}
  </Select>
);
